import ReactDOM from 'react-dom'
import { useInView } from 'react-intersection-observer'

import { SimilarCars } from './SimilarCars'
import { EditorsPosts } from './EditorsPosts'
import { OtherDylerCars } from './OtherDylerCars'
import { RelatedPosts } from './RelatedPosts'

const defaultOptions = {
  treshold: 0,
  triggerOnce: true,
  rootMargin: '150px',
}

function Footer() {
  const [refSimilarCars, inViewSimilarCars] = useInView(defaultOptions)
  const [refOtherDylerCars, inViewOtherDylerCars] = useInView(defaultOptions)
  const [refEditorsPosts, inViewEditorsPosts] = useInView(defaultOptions)
  const [refRelatedPosts, inViewRelatedPosts] = useInView(defaultOptions)

  return (
    <>
      <div ref={refSimilarCars} className="container my-6">
        {inViewSimilarCars && <SimilarCars />}
      </div>
      <div ref={refOtherDylerCars} className="container my-6">
        {inViewOtherDylerCars && <OtherDylerCars />}
      </div>
      <div ref={refEditorsPosts} className="container my-6">
        {I18n.locale === 'en' && inViewEditorsPosts && <EditorsPosts />}
      </div>
      <div ref={refRelatedPosts} className="container my-6">
        {I18n.locale === 'en' && inViewRelatedPosts && <RelatedPosts />}
      </div>
    </>
  )
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<Footer />, document.getElementById('footer-items'))
})
